import { Types } from 'mongoose';
import { IContact } from './contact';
import { IImage } from './image';
import { IProduct } from './product';
import { IUser } from './user';
import { IAccountOwned } from './account';
import { IEvent } from './event';

export interface IAddress {
  organisation: string;
  line_1: string;
  line_2: string;
  line_3: string;
  line_4: string;
  town: string;
  county: string;
  postcode: string;
  country: string;
}

export interface IOrderItemsSummary {
  downloads: IOrderDownloadItemSummary[];
  prints: IOrderPrintItemSummary[];
}

interface IOrderItemSummary {
  _id: Types.ObjectId;
  eventNames: string[];
  productFormData?: {
    id: string;
    label: string;
    value: string | boolean | number;
  }[][];
}

export interface IOrderDownloadItemSummary extends IOrderItemSummary {
  productName: string;
  ready: boolean;
  isInstantDownload: boolean;
  uploadType: string;
  image: {
    url: string;
    name: string;
  };
  downloadUrl: string;
}
export interface IOrderPrintItemSummary extends IOrderItemSummary {
  productName: string;
  shipped: boolean;
  images: {
    url: string;
    name: string;
  }[];
}

export enum OrderStatus {
  Created = 'created',
  Complete = 'complete',
  Unconfirmed = 'unconfirmed',
  Confirmed = 'confirmed',
}

export interface IOrderSummary {
  _id: Types.ObjectId;
  status: OrderStatus;
  items: IOrderItemsSummary;
  isPaid: boolean;
  isActioned: boolean;
  created_on: Date;
  subTotal: number;
  shippingCost: number;
}

export interface IOrder extends IAccountOwned {
  _id: Types.ObjectId;
  method: string;
  items: {
    _id?: Types.ObjectId;
    image_ids: Types.ObjectId[] | IImage[];
    product_id: Types.ObjectId | IProduct;
    quantity: number;
    line_price: number;
    event_ids: Types.ObjectId[] | IEvent[];
    productFormData?: Record<string, string | boolean | number>[];
  }[];
  discounts: {
    couponCode: string;
    description: string;
    amount: number;
  }[];
  shippingCost: number;
  created_on: Date;
  status: OrderStatus;
  service_id?: string;
  paymentService?: string;
  contact_id: Types.ObjectId | IContact;
  user_id?: Types.ObjectId | IUser;
  shipping_email?: string;
  shipping_address?: IAddress;
  confirmtationEmailSent: boolean;
  confirmtationEmailLastSent: Date;
  downloadsAvailableEmailSent: boolean;
  downloadsAvailableEmailLastSent: Date;
  isPaid: boolean;
  paidOn?: Date;
  isRefunded: boolean;
  refundedOn?: Date;
  isCancelled: boolean;
  cancelledOn?: Date;
  isActioned: boolean;
  actionedOn?: Date;
  accessToken?: string;
  source?: 'online' | 'kiosk';
  hubOrderId?: string;
  collectionNumber?: number;
}
